// Employment
export const EMPLOYMENT_ID = 'employment';
export const EMPLOYMENT_NAME = 'Employment';
export const INITIAL_EMPLOYMENT = {
    id: EMPLOYMENT_ID,
    name: EMPLOYMENT_NAME,
    value: 5
};

// Health
export const HEALTH_ID = 'health';
export const HEALTH_NAME = 'Health';
export const INITIAL_HEALTH = {
    id: HEALTH_ID,
    name: HEALTH_NAME,
    value: 5
};

// Popularity
export const POPULARITY_ID = 'popularity';
export const POPULARITY_NAME = 'Popularity';
export const INITIAL_POPULARITY = {
    id: POPULARITY_ID,
    name: POPULARITY_NAME,
    value: 5
};

// Public Safety
export const PUBLIC_SAFETY_ID = 'public-safety';
export const PUBLIC_SAFETY_NAME = 'Public Safety';
export const INITIAL_PUBLIC_SAFETY = {
    id: PUBLIC_SAFETY_ID,
    name: PUBLIC_SAFETY_NAME,
    value: 5
};

// Wealth
export const WEALTH_ID = 'wealth';
export const WEALTH_NAME = 'Wealth';
export const INITIAL_WEALTH = {
    id: WEALTH_ID,
    name: WEALTH_NAME,
    value: 5
};